<div class="summary-medical-order-patient-container">
    <div class="title-section" [ngClass]="{'skeleton-item background-grey': initialLoading}">
        <img src="https://s3.amazonaws.com/docs.public/images/iconos/pdf/Doc.svg" />
        <span> {{ 'shared.medicalOrder.summary.patientTitle' | translate:locale.language }} </span>
    </div>
    <span [ngClass]="{'skeleton-item background-grey': initialLoading}">
        {{patientData?.Nombre}} {{patientData?.Apellido}} <span *ngIf="patientData?.NombreTipoSangre">({{patientData.NombreTipoSangre}})</span>
    </span>
    <span [ngClass]="{'skeleton-item background-grey': initialLoading}">{{patientData?.FechaNacimiento| ageFromBirthday}}</span>
    <span [ngClass]="{'skeleton-item background-grey': initialLoading}">{{patientData?.NumeroCedula || 'Cédula disponible'}}</span>
    <span [ngClass]="{'skeleton-item background-grey': initialLoading}" *ngIf=" patientData?.Email || initialLoading">
        {{patientData?.Email}}
    </span>
    <span
        [ngClass]="{'skeleton-item background-grey': initialLoading}"
        *ngIf="patientData?.NumeroCelularParticular || patientData?.NumeroTelefonoParticular || initialLoading ">
        {{patientData?.NumeroCelularParticular || patientData?.NumeroTelefonoParticular}}
    </span>
</div>